import axios from "axios";
import * as actions from "./actionsTypes";
import messages from "../../messages";
import toastr from "toastr";
import DisciplinaryMeasurementServices from "./disciplinary_measurement.services";

toastr.options = {
  closeButton: false,
  debug: false,
  newestOnTop: false,
  progressBar: true,
  positionClass: "toast-top-right",
  preventDuplicates: false,
  onclick: null,
  showDuration: "300",
  hideDuration: "1000",
  timeOut: "5000",
  extendedTimeOut: "1000",
  showEasing: "swing",
  hideEasing: "linear",
  showMethod: "fadeIn",
  hideMethod: "fadeOut",
};

export const getDisciplinaryMeasurement = (filters) => async (dispatch) => {
  try {
    dispatch({
      type: actions.LOADING_DISCIPLINARY_MEASUREMENT,
      payload: true,
    });
    const resp = await DisciplinaryMeasurementServices.getDisciplinaryMeasurement(filters);
    dispatch({
      type: actions.GET_DISCIPLINARY_MEASUREMENT,
      payload: {
        disciplinaryMeasurement: resp.data.data,
        disciplinaryMeasurementLength: resp.data.count,
      },
    });
    dispatch({
      type: actions.DISCIPLINARY_MEASUREMENT_FAIL,
      payload: "",
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    dispatch({
      type: actions.DISCIPLINARY_MEASUREMENT_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADING_DISCIPLINARY_MEASUREMENT,
      payload: false,
    });
  }
};

export const saveDisciplinaryMeasurement = (data) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.SAVE_LOADING_DISCIPLINARY_MEASUREMENT,
      payload: true,
    });
    const resp = await DisciplinaryMeasurementServices.saveDisciplinaryMeasurement(data);
    const { disciplinaryMeasurement, disciplinaryMeasurementLength } = getState().disciplinaryMeasurement;
    const aDisciplinaryMeasurement = [...disciplinaryMeasurement, resp.data];
    dispatch({
      type: actions.GET_DISCIPLINARY_MEASUREMENT,
      payload: {
        disciplinaryMeasurement: aDisciplinaryMeasurement,
        disciplinaryMeasurementLength: disciplinaryMeasurementLength + 1,
      },
    });
    dispatch({
      type: actions.FORM_FAIL,
      payload: "",
    });
    toastr.success(messages.successMessage, "", {
      progressBar: true,
      rtl: true,
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    dispatch({
      type: actions.FORM_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.SAVE_LOADING_DISCIPLINARY_MEASUREMENT,
      payload: false,
    });
  }
};

export const editDisciplinaryMeasurement = (data, id, index) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.LOADING_DISCIPLINARY_MEASUREMENT,
      payload: true,
    });
    const resp = await DisciplinaryMeasurementServices.editDisciplinaryMeasurement(id, data);
    const { disciplinaryMeasurement, disciplinaryMeasurementLength } = getState().disciplinaryMeasurement;
    disciplinaryMeasurement[index] = resp.data;
    dispatch({
      type: actions.GET_DISCIPLINARY_MEASUREMENT,
      payload: {
        disciplinaryMeasurement: disciplinaryMeasurement,
        disciplinaryMeasurementLength: disciplinaryMeasurementLength,
      },
    });
    dispatch({
      type: actions.FORM_FAIL,
      payload: "",
    });
    toastr.success(messages.successMessage, "", {
      progressBar: true,
      rtl: true,
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    dispatch({
      type: actions.FORM_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADING_DISCIPLINARY_MEASUREMENT,
      payload: false,
    });
  }
};

export const deleteDisciplinaryMeasurement = (id, index) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.LOADING_DISCIPLINARY_MEASUREMENT,
      payload: true,
    });
    await DisciplinaryMeasurementServices.deleteDisciplinaryMeasurement(id);
    const { disciplinaryMeasurement, disciplinaryMeasurementLength } = getState().disciplinaryMeasurement;
    disciplinaryMeasurement.splice(index, 1);
    dispatch({
      type: actions.GET_DISCIPLINARY_MEASUREMENT,
      payload: {
        disciplinaryMeasurement: disciplinaryMeasurement,
        disciplinaryMeasurementLength: disciplinaryMeasurementLength - 1,
      },
    });
    dispatch({
      type: actions.DISCIPLINARY_MEASUREMENT_FAIL,
      payload: "",
    });
    toastr.success(messages.successMessage, "", {
      progressBar: true,
      rtl: true,
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    dispatch({
      type: actions.DISCIPLINARY_MEASUREMENT_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADING_DISCIPLINARY_MEASUREMENT,
      payload: false,
    });
  }
};
